/**************************************************************************************************
 *
 *  This is the main container for all project related views: Project Detail (hierarch), Project
 *  Edit/Creation, Build Edit/Creation, Task Detail, Field Task Detail
 *
 *  This views are individual components that will fit into the detail-container parent element
 *  defined in this container.
 *
 **************************************************************************************************/

import React from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import BaseComponent from '../../baseClasses/BaseComponent';
import animator from '../../helpers/animator';
import ProjectAddCard from './ProjectAddCard';
import ProjectNavCard from './ProjectNavCard';
import ProjectSearchFilter from './ProjectSearchFilter';
import LoadingDots from '../../components/LoadingDots';
import dataModel from '../../models/DataModel';
import ClientSearchHelper from '../../helpers/search/ClientSearchHelper';
import { createInfiniteScrollHandlers, DEFAULT_INFINITE_SCROLL_CONFIG } from '../../utils/infiniteScrollUtils';

import AddIcon from '../../assets/images/add-icon-white.svg';
import './ProjectsNav.scss';

export class ProjectsNav extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      projectName: '',
      showAddButton: true,
      displayAddCard: false,
    };
    this.animator = new animator();
    this.initializing = true;

    // TODO: proptypes
    if (this.props.inProjectsTab) {
      this.archivedDisabled = false;
      this.allCardEnabled = false;
      this.editEnabled = true;
      this.projectSummaryEnabled = true;
      this.baseRoute = '/projects/';
    }
    else {
      //In Tasks tab - in future extend to work with template projectsNav
      this.archivedDisabled = true;
      this.allCardEnabled = true;
      this.baseRoute = '/tasks/project/';
    }
    this.goToProjectSummary = this.goToProjectSummary.bind(this);
    this.queryChangeView = this.queryChangeView.bind(this);
    this.handleDisplayAddCard = this.handleDisplayAddCard.bind(this);
    this.handleDisplayAddProject = this.handleDisplayAddProject.bind(this);
  }

  componentDidMount() {
    if (this.props.onRegisterCallback) {
      this.props.onRegisterCallback(this.handleDisplayAddProject);
    }
    if (this.props.location.pathname.includes('summary')) {
      this.setState({ summarySelected: true });
    }
    if (this.props.location.state && this.props.location.state.projectName) {
      this.setState({ projectName: this.props.location.state.projectName });
    }
    if (this.props.viewName == 'projectCRUD' && this.state.showAddButton) {
      this.setState({ showAddButton: false });
    }
  }

  componentDidUpdate(prevProps) {
    const { navigationProjects, location } = this.props;
    let pathParts = this.props.history.parseParameters();
    if (location.pathname.includes('summary') && !this.state.summarySelected) {
      this.setState({ summarySelected: true });
    }
    else if (location.pathname.includes('edit') && this.state.summarySelected) {
      this.setState({ summarySelected: false });
    }
    else if (pathParts.params.project_id && this.state.summarySelected) {
      this.setState({ summarySelected: false });
    }
    if (this.scrollToAddCard) {
      this.scrollToAddCard = false;
      const element = document.getElementById('project-add-card');
      if (element) {
        this.scrollIntoView(element);
      }
    }
    else if (this.scrollToProject) {
      if (!this.initializing) {
        const element = document.getElementById(
          'project-' + this.scrollToProject.id
        );
        this.scrollIntoView(element);
      }
      this.scrollToProject = null;
    }
    if (navigationProjects != prevProps.navigationProjects) {

    }
    if (prevProps.resetScroll != this.props.resetScroll) {
      this.infiniteDone = false;
      this.setState({ infiniteScroll: false, resetSearchString: this.props.resetScroll, searchString: '' });
    }
    if (this.props.viewName == 'projectCRUD' && this.state.showAddButton) {
      this.setState({ showAddButton: false });
    }
    else if (prevProps.viewName && prevProps.viewName == 'projectCRUD' && prevProps.viewName != this.props.viewName) {
      this.setState({ showAddButton: true });
    }
  }

  queryChangeView(project) {
    const message = this.textMap.queryDataChanged;
    const { location } = this.props;
    const params = new URLSearchParams(location.search);
    const isProjectNew = params.get('isProjectNew');

    if(this.props.requiredDataNotAvailable || isProjectNew)
    {
      dataModel.showGlobalModal('SYSTEM_POPUP', {
        message: 'If you leave this page, the new project you are creating will be deleted. If you wish to continue, click Yes. If you do not wish to continue, click No and provide the required fields on the page to save the project.',
        cancelButtonText: this.textMap.no.toUpperCase(),
        okButtonText: this.textMap.yes.toUpperCase(),
        width: 420,
        height: 200,
        handleOwnerOk: () => {
          this.deleteNewProject();
        },
      });
    }
    else if(this.props.dataChanged){
      dataModel.showGlobalModal('SYSTEM_POPUP', {
        message: message,
        cancelButtonText: this.textMap.no.toUpperCase(),
        okButtonText: this.textMap.yes.toUpperCase(),
        width: 300,
        height: 180,
        handleOwnerOk: () => {
          dataModel.dataChanged = false;
          this.handleSelectProject(project);
        },
      });
    }
  }

  deleteNewProject(){
    dataModel.projectsDAO.deleteProject(this.props.selectedProjectId).then(response => {
      this.props.history.push('/projects/summary');
      dataModel.requiredDataNotAvailable = false;
      dataModel.dataChanged = false;
    });
  }

  /** EVENT HANDLERS */
  goToProjectSummary() {
    const pathName = '/projects/summary';
    if(window.location.pathname != pathName){
      this.props.history.push(pathName);
    }
  }

  handleSelectProject(project) {
    const { location } = this.props;
    const params = new URLSearchParams(location.search);
    const isProjectNew = params.get('isProjectNew');

    if (this.props.dataChanged || this.props.requiredDataNotAvailable || isProjectNew) {
      this.queryChangeView(project);
    }
    else {
      this.setState({ summarySelected: false });
      if (project == 'all') {
        this.props.history.push('/tasks/project/all');
      }
      else if (project) {
        let id = '';
        // TODO: this route doesn't make sense - we should change 'tasks' to something like assignedProjects or myProjects
        if (this.state.filter && this.state.filter.showArchived) {
          this.props.history.push({
            pathname: this.baseRoute + project.id,
            state: {
              showArchived: true,
            },
          });
        }
        else {
          this.props.history.push(this.baseRoute + project.id);
        }
        id = 'project-' + project.id;
        if (project) {
          const element = document.getElementById(id);
          if (element) {
            const rect = element.getBoundingClientRect();
            let parentElement = element.parentElement;
            if (parentElement) {
              parentElement = parentElement.parentElement;
            }

            if (parentElement) {
              const parentRect = parentElement.getBoundingClientRect();
              if (rect.top < parentRect.top || rect.bottom > parentRect.bottom) {
                this.scrollIntoView(element);
              }
            }
          }
        }
      }
    }
  }

  handleDeleteProject(deletedProjectId) {
    let project;
    if (this.props.favorites.projects && this.props.favorites.projects.length) {
      project = this.props.favorites.projects[0];
    }
    else if (this.props.navigationProjects.projects.length){
      project = this.props.navigationProjects.projects[0];
    }
    else {
      if (this.props.handleProjectDelete) {
        this.props.handleProjectDelete(deletedProjectId);
      }
      return;
    }
    dataModel.requiredDataNotAvailable = false;
    // Only navigate to another project if it's not the one we're deleting
    if (project.id !== deletedProjectId) {
      this.handleSelectProject(project);
    }
    if (this.props.handleProjectDelete) {
      this.props.handleProjectDelete(deletedProjectId);
    }
  }

  handleEditProject(project) {
    this.props.history.push('/projects/' + project.id + '/edit');
    this.isEditing = true;
    const element = document.getElementById('project-' + project.id);
    if (element) {
      this.scrollIntoView(element);
    }
  }

  handleDisplayAddCard() {
    this.setState({ displayAddCard: !this.state.displayAddCard });
  }

  handleDisplayAddProject() {
    this.setState({ displayAddCard: true, showAddButton: true });
  }

  handleCloseAddCard() {
    this.setState({ displayAddCard: false, showAddButton: true });
  }

  handleProjectAdd(project) {
    this.scroller.scrollTop = 0;
    if (this.props.handleProjectAdd) {
      this.props.handleProjectAdd(project);
    }
    this.handleCloseAddCard();
    this.props.history.push(`/projects/${project.id}/edit?isProjectNew=true`);
  }

  handleProjectCopied(projectCopied) {
    this.scroller.scrollTop = 0;
    if (this.props.handleProjectAdd) {
      this.props.handleProjectAdd(projectCopied, true);
    }
  }

  /** SEARCH/FILTER FUNCTIONS */
  handleFilterFavorites() {
    const { favorites } = this.props;
    const { filter, searchString } = this.state;
    let filteredFavorited = [];
    if (favorites && favorites.projects) {
      for (let favorite of favorites.projects) {
        // handle filters
        if (filter && (
            (filter.project_type && (!favorite.project_type || (favorite.project_type.id != filter.project_type.id))) ||
            (filter.state && favorite.location && favorite.location.state != filter.state) ||
            (filter.statuses && favorite.status && !filter.statuses.includes(favorite.status)) ||
            (filter.markets && favorite.market && !filter.markets.includes(favorite.market)) ||
            (filter.showArchived && !favorite.archived_at)
          )) {
          continue;
        }
        // handle search string
        else if(ClientSearchHelper.projectFitsSearchCriteria(searchString, favorite)) {
          filteredFavorited.push(favorite);
        }
      }
    }
    return filteredFavorited;
  }

  handleSearchChange(searchString) {
    const { favorites } = this.props;
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
    }
    let { filter } = this.state;
    const self = this;
    this.searchTimer = setTimeout(() => {
      const perPage = Math.floor((window.innerHeight - 220) / 97) - (Math.min(favorites ? favorites.length : 0, 2) * 97);
      self.setState({ infiniteScroll: false, searchString });
      self.infiniteDone = false;
      this.props.handleProjectSearch(filter, searchString, perPage);
    }, 400);
  }

  handleFilterChange(filter) {
    const { favorites } = this.props;
    this.perPage =  Math.floor((window.innerHeight - 220) / 97) - (Math.min(favorites ? favorites.length : 0, 2) * 97);
    this.props.handleFilterProjects(filter).then(() => {
      this.infiniteDone = false;
      this.setState({ filter, infiniteScroll: false });
    });

  }

  /** SCROLLING/PAGINATION FUNCTIONS */
  scrollIntoView(element) {
    var rect = element.getBoundingClientRect();
    var parentElement = element.parentElement;
    var parentRect = parentElement.getBoundingClientRect();
    var scrollRect = this.scroller.getBoundingClientRect();
    const id = this.scroller.id;
    if (rect.top <= scrollRect.top) {
      let amountAlreadyScrolled = Math.abs(scrollRect.top - parentRect.top);
      let additionalScroll = scrollRect.top - rect.top;
      let scrollAmount = amountAlreadyScrolled - additionalScroll;
      const ani = this.animator.createPropertyAnimation(id, 250, {
        verticalScroll: {
          startVal: amountAlreadyScrolled,
          endVal: scrollAmount,
        },
      });
      this.animator.addAnimation(ani);
      this.animator.processAnimationQueue();
    } else if (rect.bottom >= scrollRect.bottom) {
      let amountAlreadyScrolled = Math.abs(scrollRect.top - parentRect.top);
      let additionalScroll = rect.bottom - scrollRect.bottom;
      let scrollAmount = amountAlreadyScrolled + additionalScroll;
      const ani = this.animator.createPropertyAnimation(id, 250, {
        verticalScroll: {
          startVal: amountAlreadyScrolled,
          endVal: scrollAmount,
        },
      });
      this.animator.addAnimation(ani);
      this.animator.processAnimationQueue();
    }
  }

  getInfiniteScrollHandlers() {
    // Always create fresh handlers to get current state values
    this._infiniteScrollHandlers = createInfiniteScrollHandlers(this, {
      loadMore: () => {
        this.props.getNextPage().then(fetchedProjects => {
          if (fetchedProjects.ids.length >= this.props.navigationProjects.totalProjects) {
            this.infiniteDone = true;
          }
          this._infiniteScrollHandlers.setLoadingComplete();
        });
      },
      currentLength: (this.props.navigationProjects && this.props.navigationProjects.projects && this.props.navigationProjects.projects.length) || 0,
      totalItems: (this.props.navigationProjects && this.props.navigationProjects.totalProjects) || 0,
    });
    return this._infiniteScrollHandlers;
  }

  handleLoadMoreProjects() {
    const handlers = this.getInfiniteScrollHandlers();
    handlers.handleLoadMore();
  }

  hasMoreProjects() {
    const handlers = this.getInfiniteScrollHandlers();
    return handlers.hasMoreFn();
  }

  shouldShowEndMessage() {
    const handlers = this.getInfiniteScrollHandlers();
    return handlers.shouldShowEndMessageFn();
  }

  /** RENDER FUNCTIONS */
  createProjectCards() {
    const { navigationProjects, allProjects, selectedProjectId } = this.props;
    const { summarySelected } = this.state;
    let projectCards = [];
    if (navigationProjects && navigationProjects.projects && navigationProjects.projects.length) {
      const noFavorites = navigationProjects.projects.filter(project => {
        return true;
      });
      projectCards = noFavorites.map(project => {
        const selected = !summarySelected && !allProjects && selectedProjectId == project.id;

        if (project.newlyCreated) {
          if (!this.initializing) {
            this.scrollToProject = project;
          }
        }
        return (
          <ProjectNavCard
            id={'project-' + project.id}
            key={'nav-project-' + project.id}
            project={project}
            selectProject={this.handleSelectProject}
            projectCopied={this.handleProjectCopied}
            editProject={this.handleEditProject}
            selected={selected}
            handleRemoveFavorite={this.props.handleRemoveFavorite}
            handleMakeFavorite={this.props.handleMakeFavorite}
            isFavorite={false}
            editEnabled={this.editEnabled}
            handleDeleteProject={this.handleDeleteProject}
            addButton={false}
          />
        );
      });
    }

    return projectCards;
  }
  
  createFavoriteCards() {
    const { favorites, allProjects, selectedProjectId } = this.props;
    const { summarySelected } = this.state;
    if (favorites) {
      let filteredFavorites = favorites.projects;
      if (this.props.currentCompany && this.props.currentCompany.admin_company) {
        return [];
      }

      if (this.state.searchString || this.state.filter) {
        filteredFavorites = this.handleFilterFavorites();
      }

      if (!filteredFavorites) {
        return null;
      }

      const projectCards = filteredFavorites.map(favorite => {
        if (favorite) {
          const selected = !summarySelected && !allProjects && selectedProjectId == favorite.id;
          return (
            <ProjectNavCard
              key={'favorite-' + favorite.id}
              project={favorite}
              selectProject={this.handleSelectProject}
              projectCopied={this.handleProjectCopied}
              selected={selected}
              isFavorite={true}
              editProject={this.handleEditProject}
              handleRemoveFavorite={this.props.handleRemoveFavorite}
              editEnabled={this.editEnabled}
              handleDeleteProject={this.handleDeleteProject}
            />
          );
        }
        return null;
      });

      return projectCards;
    }
    else {
      return null;
    }
  }

  render() {
    const { navigationProjects } = this.props;
    const { summarySelected } = this.state;

    if (!navigationProjects) {
      return null;
    }

    const favoriteNavCards = this.createFavoriteCards();
    const projectNavCards = this.createProjectCards();

    this.initializing = false;

    let projectAllCard;
    if (this.props.permissions.canCreateProject && this.state.displayAddCard) {
      projectAllCard =
        <ProjectNavCard
          id={'project-all'}
          key={'project-all'}
          allProjects={true}
          selectProject={this.handleSelectProject}
          projectCopied={this.handleProjectCopied}
          editProject={this.handleEditProject}
          selected={this.props.allProjects}
          editEnabled={this.editEnabled}
          handleDeleteProject={this.handleDeleteProject}
        />;
    }
    let addButton = null;
    if (this.props.permissions.canCreateProject && this.state.showAddButton && !this.props.currentCompany.admin_company) {
      addButton = <img className="add-button" src={AddIcon} alt="Add"
          onClick={this.handleDisplayAddCard} />;
    }
    let projectAddCard = null;
    if (this.props.permissions.canCreateProject && this.state.displayAddCard) {
      projectAddCard = (
        <ProjectAddCard
          id="project-add-card"
          closeAddCard={this.handleCloseAddCard}
          handleProjectAdd={this.handleProjectAdd}
          setProjectHierarchy={this.handleSelectProject}
        />
      );
      this.scrollToAddCard = true;
    }

    let projectsLabel = this.textMap.projects;
    let favoritesSection = (
        <div className="favorites">
          <div className="section-header">
            {this.textMap.favorites.toUpperCase()}
            <span className="project-count">
              {!this.props.currentCompany.admin_company && favoriteNavCards && favoriteNavCards.length ? favoriteNavCards.length : 0}
            </span>
          </div>
          <div className="favorites-scroller" >
            <div className="favorites-list">{favoriteNavCards}</div>
          </div>
        </div>
      );
    let searchFilter =
      <ProjectSearchFilter
        handleSearchChange={this.handleSearchChange}
        handleFilterChange={this.handleFilterChange}
        selectedFilters={this.state.filter}
        archivedDisabled={this.archivedDisabled}
        search={this.state.projectName}
        fromPOR={true}
        resetSearchString={this.state.resetSearchString}
        isMarketFilterEnabled={this.props.isMarketFilterEnabled}
      />;

    let noneFound = null;
    const hasSearchOrFilter = this.state.searchString || this.state.filter;
    const noProjectsMatch = projectNavCards.length === 0;
    const noFavoritesMatch = !favoriteNavCards || favoriteNavCards.length === 0;
    if (hasSearchOrFilter && noProjectsMatch && noFavoritesMatch) {
      noneFound = <div className="no-matches-indicator">No Results Found...</div>;
    }

    let projectCount = (
        <span className="project-count">
          {this.props.navigationProjects.totalProjects}
        </span>
      );
    //    let projectsScrollerHeight = window.innerHeight - 76 - 84 - 28 - 28

    let addPlusButton = null;
     
    if (this.props.permissions.canCreateProject && !this.state.displayAddCard) {
      addPlusButton = <img className="add-button" src={AddIcon} alt="Add"
        onClick={this.handleDisplayAddCard} />;
    }

    const favoriteAllowance = !favoriteNavCards ? '' : favoriteNavCards.length == 1 ? ' favorite-one' : favoriteNavCards.length == 2 ? ' favorite-two' : favoriteNavCards.length >= 3 ? ' favorite-three' : ' favorite-none';
    return (
      <div className={'projects-nav'}>
        <div className="projects">
          <div className="section-header">{this.textMap.projects.toUpperCase()}{addPlusButton}</div>
        </div>
        {searchFilter}
        { this.projectSummaryEnabled &&
          <div onClick={this.goToProjectSummary} className={'projects-nav__summary' + (summarySelected ? ' projects-nav__summary--selected' : '')}>
          {'Project Summary'}
          </div>
        }
        {favoritesSection}
        <div className={'projects' + favoriteAllowance}>
          <div className="section-header">
            {projectsLabel.toUpperCase()}
            {projectCount}
          </div>
          <div
            id="projects-scroller"
            className={'projects-scroller'}
            ref={element => {
              this.scroller = element;
            }}
          >
            <InfiniteScroll
              dataLength={(this.props.navigationProjects && this.props.navigationProjects.projects && this.props.navigationProjects.projects.length) || 0}
              next={this.handleLoadMoreProjects}
              hasMore={this.hasMoreProjects()}
              loader={
                <div className="project-nav-loading-indicator" style={{ 
                  padding: '20px 0', 
                  margin: '10px auto',
                  textAlign: 'center',
                }}>
                  <LoadingDots />
                </div>
              }
              endMessage={
                this.shouldShowEndMessage() ? (
                  <div className="scroll-footer">
                    <div className="more-projects-card footer-card">
                      No more projects to load
                    </div>
                  </div>
                ) : null
              }
              scrollableTarget="projects-scroller"
              scrollThreshold={DEFAULT_INFINITE_SCROLL_CONFIG.scrollThreshold}
            >
              <div
                className="projects-list"
                ref={element => {
                  this.list = element ? element : this.list;
                }}
              >
                {projectAllCard}
                {projectAddCard}
                {projectNavCards}
                {noneFound}
              </div>
            </InfiniteScroll>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {

  return {
    dataChanged: state.main.dataChanged,
    requiredDataNotAvailable: state.main.requiredDataNotAvailable,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null,
  };
};

export default withRouter(connect(mapStateToProps)(ProjectsNav));



// WEBPACK FOOTER //
// ./src/components/ProjectsNav/index.js